import request from '@/router/axios'

export function getSigninStatisticsSummaryTrend (param) {
  return request({
    url: '/admin/admin/sign-in/statistic',
    method: 'get',
    params: param,
  })
}

export function exportAnalysisSummaryData(obj) {
  return request({
    url: '/admin/admin/sign-in/statistic/export',
    method: 'put',
    data: obj,
  })
}